export default {
	欢迎回来: 'Welcome back',
	设置密码: 'Set password',
}
